@let newsItemSlides = newsItemSlides$ | async; @if (newsItemSlides?.length > 0) {
<div>
  <swiper-container dkSwiper [config]="swiperConfig$ | async" (reachEnd)="endReached()" init="false">
    @for (slide of newsItemSlides; track trackByIndex($index); let i = $index) {
    <swiper-slide class="flex-col">
      @for (item of slide.items; track trackById($index, item)) {
      <div
        [style.--i18n-newsfeed-item-unread]="'\'' + ('newsfeed.item.unread' | translate) + '\''"
        class="news-item"
        (click)="viewItem(item.id)"
        [class.unread]="!(readItems$ | async).includes(item.id)"
      >
        <app-doenkids-image [mediaItem]="{ uuid: item.media_uuid, description: '' }"></app-doenkids-image>
        <div class="text-overlay flex-col justify-between items-start">
          <span class="date">
            {{ item.organization_unit_name }} •
            {{ item.show_from | from_now : 'D MMMM YYYY' | async }}
          </span>
          <div class="text">
            <div class="title">{{ item.subject }}</div>
            <span class="content" [innerHTML]="item.content | htmlToPlaintext"></span>
          </div>
        </div>
      </div>
      }
    </swiper-slide>
    } @if ((newsItemsLoading$ | async) && !(end$ | async)) {
    <swiper-slide class="end swiper-slide">
      <div class="container">
        <mat-spinner diameter="48"></mat-spinner>
      </div>
    </swiper-slide>
    }
  </swiper-container>
  <div class="swiper-pagination"></div>
</div>
} @else {
<div class="container">
  <div class="no-data flex-col justify-center items-center">
    <span>{{ 'newsfeed.no_news' | translate }}</span>
  </div>
</div>
}
